export const TITLE_LAYOUT_SCHEMA = objContent => ({
  color: '#000',
  font: 'Inter',
  'font-size': '32px',
  'font-style': '',
  weight: '',
  ...objContent
})

export const SUBTITLE_LAYOUT_SCHEMA = objContent => ({
  color: '#000',
  font: 'Inter',
  'font-size': '24px',
  'font-style': '',
  weight: '',
  ...objContent
})

export const TEXT_LAYOUT_SCHEMA = objContent => ({
  color: '#000',
  font: 'Inter',
  'font-size': '16px',
  'font-style': '',
  weight: '',
  ...objContent
})

export const OBSERVATION_LAYOUT_SCHEMA = objContent => ({
  color: '#000',
  font: 'Inter',
  'font-size': '13px',
  'font-style': '',
  weight: '',
  ...objContent
})

export const BUTTON_LAYOUT_SCHEMA = objContent => ({
  'background-color': '#000',
  color: '#FFFFFF',
  'border-radius': '24px',
  ...objContent
})

export const BG_LAYOUT_SCHEMA = objContent => ({
  'background-color': '#FFFFFF',
  'background-image': '',
  'background-type': 'color', // color, image, video
  'background-video': 'https://cdn.blueticket.com.br/assets/institucional.mp4',
  ...objContent
})
